import { SvgIcon } from '@mui/material'

export default function RedFlagIcon() {
  return (
    <SvgIcon sx={{ width: 14, height: 14 }}>
      <svg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <title>Red Flag</title>
        <path
          d='M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM10.5 9.1H8.134C7.868 9.1 7.623 8.953 7.511 8.715L7 7.7H5.25V10.675C5.25 10.962 5.012 11.2 4.725 11.2C4.438 11.2 4.2 10.962 4.2 10.675V4.2C4.2 3.815 4.515 3.5 4.9 3.5H7.966C8.232 3.5 8.477 3.647 8.589 3.885L9.1 4.9H10.5C10.885 4.9 11.2 5.215 11.2 5.6V8.4C11.2 8.785 10.885 9.1 10.5 9.1Z'
          fill='#FF4D1A'
        />
      </svg>
    </SvgIcon>
  )
}
